import { Failure } from '../../entities/Failure';
import { CreateGrupoAdicionais } from '../../entities/GrupoAdicionais';
import { Success } from '../../entities/Success';
import api from '../api';
import * as yup from 'yup';

export async function createSelectedAdditionalsGroupsByGroup(
  createDto = new CreateGrupoAdicionais(),
) {
  try {
    const schema = yup.object({
      IdEmpresa: yup.number().required().nonNullable().integer().positive(),
      IdGrupo: yup.string().required().nonNullable(),
      IdGrupoSelecao: yup.string().required().nonNullable(),
      Ativo: yup.boolean().optional(),
    });

    await schema.validate(createDto);

    const { data } = await api.post(`/grupo-adicionais`, createDto);

    return new Success( data );
  } catch (error) {
    console.log(error);

    return new Failure();
  }
}
